import styled from '@emotion/styled';
import Button from '@shared/components/core/button/CoreButton';
import ContentDialog from '@shared/components/core/dialog/ContentDialog';
import SubSectionRow from '@shared/components/core/headers/SubSectionRow';
import CurrentUserContainer from '@shared/hooks/state/CurrentUserContainer';
import useSignout from '@shared/hooks/useSignout';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

export default function DeleteUserSection() {
    const { t } = useTranslation('common');
    const { deleteCurrentUser } = CurrentUserContainer.useContainer();
    const [showDialog, setShowDialog] = useState(false);
    const { clearAndReload } = useSignout();

    const handleDeleteAccount = async () => {
        const result = await deleteCurrentUser();
        if (result?.resultType === 'Ok') {
            clearAndReload();
        }
    };

    const showDeleteConfirmation = () => {
        setShowDialog(true);
    };

    return (
        <>
            <SubSectionRow title={t('dangerZone')} />
            <StyledButton startIcon="delete" $size="quick" $color="quick" onClick={showDeleteConfirmation}>
                {t('account.delete.button')}
            </StyledButton>
            {showDialog && (
                <ContentDialog
                    open={showDialog}
                    onClose={() => setShowDialog(false)}
                    onCancel={() => setShowDialog(false)}
                    onConfirm={handleDeleteAccount}
                    confirmButtonText={t('account.delete.confirm')}
                    title={t('account.delete.title')}
                    description={t('account.delete.description')}
                />
            )}
        </>
    );
}

const StyledButton = styled(Button)`
    width: fit-content;
    margin: auto;
`;
